// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1x9ip","tab":"Tabs_tab__2eGol","tabActive":"Tabs_tabActive__1UZ8z"};